module.exports = __webpack_public_path__ + "img/c_803.41b89cb7.jpg";